module.exports = __webpack_public_path__ + "static/media/halo-massage.1d84ba26.webp";